<template>
  <header>
    <div class="header-body">
      <div class="logo" @click="headerLogoClick">
        <img src="../assets/img/rtaLogo/logo-beta.svg" alt="" />
      </div>
      <div>
        <Aside />
      </div>
      <div class="opt-wrapper">
        <el-button type="text" class="question" @click="questionClick()" :style="
            path == '/Question'
              ? `backgroundImage:url(${remoreBg})`
              : `backgroundImage:url(${kabanBg})`
          ">
        </el-button>
        <el-popover placement="bottom" width="300" trigger="hover" popper-class="messagePopover" @show="doShow()"
          @hide="doClose()">
          <div class="popover-header">
            <div class="popover-box">
              <span>私信</span>
              <!-- <el-button type="text" @click="clearAwarClick">清空</el-button> -->
            </div>
          </div>
          <div class="popover-content" style="display: none" ref="tableRef">
            <el-table :data="inboxNum" style="width: 100%">
              <template slot="empty">
                <el-empty :image-size="100" :image="require('../assets/img/rtaLogo/default-photo-te.svg')"
                  description="没有新私信"></el-empty>
              </template>
              <el-table-column prop="messageName" label="收信" width="">
                <template slot-scope="scope" v-if="messageDisplay">
                  <el-button type="text" class="message" @click="detailClick(scope.row.messageId)">
                    <div style="display: flex">
                      <div class="messageName">{{ scope.row.messageName }}</div>
                      给你发来1条私信
                    </div>

                    <div class="sendtime">
                      {{ scope.row.sendTime.substring(0, 10) }}
                    </div>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 点击主题跳转详情 -->
            <el-dialog :title="user" class="privaTetterDialog" :visible.sync="detailDialog" width="720px"
              :before-close="handleClose" append-to-body>
              <el-form :model="replayForm" :rules="replayRules" ref="replayForm" label-width="54px">
                <el-form-item label="主题" prop="replyContent">
                  <el-input v-model="replayForm.replyContent"></el-input>
                </el-form-item>
                <el-form-item label="日期" prop="replyContent">
                  <el-input v-model="replayForm.replyTime" placeholder="请输入主题"></el-input>
                </el-form-item>
                <el-form-item class="textarea-item">
                  <el-input disabled type="textarea" v-model="replayForm.replayLetter" maxlength="500" show-word-limit
                    class="textarea" style=" 100%">
                  </el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="replays">回复</el-button>
              </div>
              <!-- 嵌套回复私信 -->
              <el-dialog width="720px" :title="user" :visible.sync="replayClick" class="answerLetterDialog"
                :before-close="handleClose" append-to-body>
                <el-form :model="replayForm" :rules="replayRules" ref="replayForm" label-width="54px">
                  <el-form-item label="主题" prop="replyContent">
                    <el-input v-model="replayForm.replyL"></el-input>
                  </el-form-item>
                  <el-form-item label="内容" prop="replayLetter" class="content-row">
                    <el-input type="textarea" style="resize: none" :rows="2" resize="none"
                      :autosize="{ minRows: 2, maxRows: 2 }" v-model="replayForm.replayLetter"></el-input>
                  </el-form-item>
                  <el-form-item class="textarea-item" prop="textarea">
                    <el-input type="textarea" placeholder="说点什么吧" v-model="replayForm.textarea" maxlength="500"
                      show-word-limit class="textarea" style=" 100%">
                    </el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="replayReset('replayForm')">取 消</el-button>
                  <el-button type="primary" @click="submitForm('replayForm')">发送</el-button>
                </div>
              </el-dialog>
            </el-dialog>
          </div>
          <div class="popover-content popover-err" style="display: flex" ref="nullRef">
            <div class="inbox-error">
              <img src="../assets/img/rtaLogo/default-page.svg" alt="" />
              <span>没有新私信</span>
            </div>
          </div>
          <div class="popover-f">
            <el-button type="text" @click="viewAllClick()">
              查看全部
            </el-button>
          </div>
          <el-button slot="reference" type="text" class="private-letter-img" :show="openShow" :style="
              path == '/PrivaTeLetter' || isClick == true
                ? `backgroundImage:url(${yellowBg})`
                : `backgroundImage:url(${whiteBg})`
            ">
            <!-- <div style="display: none" ref="numRef" class="num">
            {{ inboxNum.length }}
          </div> -->
            <div v-show="inboxNum.length > 0" class="num">
              {{ inboxNum.length }}
            </div>
          </el-button>
        </el-popover>
        <div class="login" ref="loginRef" style="display: flex">
          <el-button type="text" @click="isLoginClick">登录</el-button>
          <el-dialog width="1139px" class="previewDialog" :visible.sync="dialogFormVisible" @close="resetRegister"
            :modal-append-to-body="false" :close-on-click-modal="false">
            <div class="popup-content">
              <div class="loginRight">
                <div style="text-align: left">
                  <img src="../assets/img/rtaLogo/logo-beta.svg" alt="" />
                  <div class="title">二级交易市场综合服务平台</div>
                  <el-form :model="fromData" :rules="rules" ref="fromData" class="demo-ruleForm">
                    <el-form-item prop="nickname" class="inputDeep">
                      <span>账号</span>
                      <el-input v-model="fromData.name" placeholder="请输入邮箱" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                      <span>密码</span>
                      <el-col :span="23">
                        <el-form-item class="inputDeep">
                          <el-input type="password" placeholder="请输入密码" class="psd" v-model="fromData.password"
                            oninput="value=value.replace(/^[a-zA-Z0-9]{30,32}$/)" v-if="ifDisplay" />
                          <el-input type="text" placeholder="请输入密码" class="psd" v-model="fromData.password"
                            oninput="value=value.replace(/^[a-zA-Z0-9]{30,32}$/)" v-else />
                        </el-form-item>
                      </el-col>
                      <el-col :span="1">
                        <el-form-item class="pasEye">
                          <span v-show="ifDisplay" @click="ifDisplay = !ifDisplay"><span
                              class="iconfont icon-biyanjing"></span></span>
                          <span v-show="!ifDisplay" @click="ifDisplay = !ifDisplay"><span
                              class="iconfont icon-yanjing"></span></span>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                  </el-form>
                  <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitClick">登录</el-button>
                  </div>
                  <div class="sign_in">
                    <el-checkbox style="height: 19.22px; line-height: 19.22px" v-model="isRemember">记住密码</el-checkbox>
                    <a target="_blank"
                      href="https://edu.rta-finance.com/register?goto=https%3A//edu.rta.academy/page/commissionagreement"
                      class="sign-in">立即注册</a>
                  </div>
                </div>
              </div>
              <div class="loginLeft">
                <img src="../assets/img/login/welcome.svg" alt="" />
              </div>
            </div>
          </el-dialog>
        </div>
        <div style="display: none" ref="popoverRef" class="logging-status">
          <el-popover placement="bottom" width="200" class="headPortrait" trigger="hover" popper-class="wrap">
            <div class="loginPopover" style="text-align: center">
              <div class="user-name">
                <span onload="load_data()">
                  <div class="vip_avatar">
                    <div class="vipPic">
                      <img :src="imgUrl" alt="" />
                    </div>
                    <div class="avatar" @click="userClick()">
                      <img :src="avatar" alt="" style="" />
                    </div>
                  </div>
                  <div class="nickName" :title="nickName">{{ nickName }}</div>
                </span>
              </div>
              <div class="user-button">
                <el-button type="text" class="newly_increased" @click="dotomapOppen()" v-if="isPointShow">
                  <!-- <a target="_blank" :href="letterFlagUrl">个人资料</a> -->
                  添加点阵图
                </el-button>

                <!-- 添加点阵图dialog对话框 -->
                <el-dialog title="" width="" class="dotmapDialog" :visible.sync="dotmapDialog" append-to-body
                  :close-on-click-modal="false">
                  <div class="body">
                    <div class="tittle">RTA分析部点阵图</div>
                    <el-table :data="tableData" style="width: 1180px" class="dotmapTable">
                      <el-table-column type="index" label="序列" align="center">
                      </el-table-column>
                      <el-table-column label="姓名" width="110" align="">
                        <template slot-scope="scope">
                          <el-select v-model="scope.row.user_id" placeholder="请选择" class="dotmapTable-name">
                            <el-option v-for="item in userIdOption" :key="item.value" :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column label="短中期" align="center">
                        <el-table-column prop="province" label="多空方向" width="85">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.shortPoint" placeholder="请选择">
                              <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column label="是否开仓" width="85" align="center">
                          <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.shortIsPosition">
                              <el-radio :label="1">是</el-radio>
                              <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                        <el-table-column label="开仓方向" width="85" align="center">
                          <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.shortPositionSide"
                              v-show="scope.row.shortIsPosition == 1" :disabled="
                                scope.row.shortIsPosition == 1 ? !edit : edit
                              ">
                              <el-radio label="多"></el-radio>
                              <el-radio label="空"></el-radio>
                            </el-radio-group>
                            <el-radio-group v-show="scope.row.shortIsPosition == 0" disabled>
                              <el-radio label="">多</el-radio>
                              <el-radio label="">空</el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                        <el-table-column label="杠杠倍数" width="85" align="center">
                          <template slot-scope="scope">
                            <el-input v-show="scope.row.shortIsPosition == 1" v-model="scope.row.shortPositionLeverage"
                              placeholder="" :disabled="
                                scope.row.shortIsPosition == 1 ? !edit : edit
                              "></el-input>
                            <div v-show="scope.row.shortIsPosition == 0">-</div>
                          </template>
                        </el-table-column>
                      </el-table-column>
                      <el-table-column label="中期" align="center">
                        <el-table-column prop="province" label="多空方向" width="85">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.midPoint" placeholder="请选择">
                              <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column label="是否开仓" width="85" align="center">
                          <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.midIsPosition">
                              <el-radio :label="1">是</el-radio>
                              <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                        <el-table-column label="开仓方向" width="85" align="center">
                          <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.midPositionSide" v-show="scope.row.midIsPosition == 1"
                              :disabled="
                                scope.row.midIsPosition == 1 ? !edit : edit
                              ">
                              <el-radio label="多"></el-radio>
                              <el-radio label="空"></el-radio>
                            </el-radio-group>
                            <el-radio-group v-show="scope.row.midIsPosition == 0" disabled>
                              <el-radio label="">多</el-radio>
                              <el-radio label="">空</el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                        <el-table-column label="杠杠倍数" width="85" align="center">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.midPositionLeverage" v-show="scope.row.midIsPosition == 1"
                              placeholder="" :disabled="
                                scope.row.midIsPosition == 1 ? !edit : edit
                              "></el-input>
                            <div v-show="scope.row.midIsPosition == 0">-</div>
                          </template>
                        </el-table-column>
                      </el-table-column>
                      <el-table-column label="长期" align="center">
                        <el-table-column prop="province" label="多空方向" width="85">
                          <template slot-scope="scope">
                            <el-select v-model="scope.row.longPoint" placeholder="请选择">
                              <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                          </template>
                        </el-table-column>
                        <el-table-column label="是否开仓" width="85" align="center">
                          <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.longIsPosition">
                              <el-radio :label="1">是</el-radio>
                              <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                        <el-table-column label="开仓方向" width="85" align="center">
                          <template slot-scope="scope">
                            <el-radio-group v-model="scope.row.longPositionSide" v-show="scope.row.longIsPosition == 1"
                              :disabled="
                                scope.row.longIsPosition == 1 ? !edit : edit
                              ">
                              <el-radio label="多"></el-radio>
                              <el-radio label="空"></el-radio>
                            </el-radio-group>
                            <el-radio-group v-show="scope.row.longIsPosition == 0" disabled>
                              <el-radio label="">多</el-radio>
                              <el-radio label="">空</el-radio>
                            </el-radio-group>
                          </template>
                        </el-table-column>
                        <el-table-column label="杠杠倍数" width="85" align="center">
                          <template slot-scope="scope">
                            <el-input v-model="scope.row.longPositionLeverage" v-show="scope.row.longIsPosition == 1"
                              placeholder="" :disabled="
                                scope.row.longIsPosition == 1 ? !edit : edit
                              "></el-input>
                            <div v-show="scope.row.longIsPosition == 0">-</div>
                          </template>
                        </el-table-column>
                      </el-table-column>
                    </el-table>
                  </div>

                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dotmapDialog = false">取 消</el-button>
                    <el-button type="primary" @click="dotmapClick">确 定</el-button>
                  </div>
                </el-dialog>

                <el-button type="text" class="newly_increased" @click="privateLetterClick">实盘管理</el-button>

                <el-button type="text" class="newly_increased">
                  <!-- <a target="_blank" :href="letterFlagUrl">个人资料</a> -->
                  <a target="_blank" href="https://edu.rta-finance.com/settings">个人资料</a>
                </el-button>
                <el-button type="text" class="newly_catalogue">
                  <a target="_blank" href="https://edu.rta-finance.com/settings/security">修改密码</a></el-button>
              </div>
              <div class="log_out">
                <el-button type="text" @click="logoutClick">退出登录</el-button>
              </div>
            </div>
            <el-button slot="reference" type="text">
              <img :src="avatar" alt="" style="" />
            </el-button>
          </el-popover>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { getUserAsset } from '../api/User';
  import { sendPointShow, addPoint } from '../api/Home.js';
  import Aside from './Aside.vue';
  import { getUsersLogin, getUserInfo, getLogout } from '@/api/login.js';
  import {
    sendBindingUpdate,
    deleteBinding,
    getBindingList,
  } from '@/api/apiKey.js';
  import {
    getMessageInbox,
    getMessageInfoContent,
    getMessageSendInfo,
  } from '@/api/message.js';
  export default {
    name: 'Header',
    components: { Aside },
    data() {
      return {
        avatar:
          'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: '',
        },
        formLabelWidth: '120px',
        fromData: {
          name: '',
          password: '',
        },
        rules: {
          name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
        ifDisplay: true,
        ruleForm: {
          name: '',
        },
        isRemember: false,
        messageName: '',
        messageDisplay: true,
        avatar: '',
        vipName: '',
        imgUrl: '',
        nickName: '',
        allAccountInfoData: [
          {
            id: '',
            name: '',
          },
        ],
        about: '',
        //详情页对话框
        detailDialog: false,
        replayClick: false,
        messageName: 'Eugenia Freeman',
        replayForm: {
          replyL: '',
          replyContent: '',
          replyTime: '',
          replayLetter: '',
          textarea: '',
          uuid: '',
        },

        replayRules: {
          textarea: [
            { required: true, message: '请填写回复内容', trigger: 'change' },
          ],
        },
        user: '',
        msg: '',
        inboxData: [],
        inboxNum: [],
        flag: true,
        letterFlag: true,
        letterFlag: '',
        letterFlagUrl: '',
        isReadArr: [],
        isRead: true,
        path: '',
        kabanBg: require('../assets/img/rtaLogo/question-o.svg'),
        remoreBg: require('../assets/img/rtaLogo/question.svg'),
        messagePath: '',
        whiteBg: require('../assets/img/rtaLogo/private-letter-y-o.svg'),
        yellowBg: require('../assets/img/rtaLogo/private-letter-y.svg'),
        isClick: false,
        apiNameArr: [],
        dotmapDialog: false,
        dotmapForm: {
          name: '',
          region: '',
        },
        formLabelWidth: '120px',
        options: [
          {
            value: '弃票',
            label: '弃票',
          },
          {
            value: '多头',
            label: '多头',
          },
          {
            value: '震荡偏多',
            label: '震荡偏多',
          },
          {
            value: '中立',
            label: '中立',
          },
          {
            value: '震荡偏空',
            label: '震荡偏空',
          },
          {
            value: '空头',
            label: '空头',
          },
        ],
        userIdOption: [
          {
            value: 4,
            label: 'RTA.Ruomise',
          },
          {
            value: 7,
            label: 'RTA.Yuche',
          },
          {
            value: 13,
            label: 'RTA.qianye',
          },
          {
            value: 15,
            label: 'RTA.Minyue',
          },
          {
            value: 16,
            label: 'RTA.Natalie',
          },
        ],
        tableData: [],
        addPointData: [],
        isShow: true,
        isPointShow: true,
        currentTime: '',
        aaa: '',
        bbb: '',
        ccc: '',
        edit: true,
        shortLeverage: '',
        midLeverage: '',
        longLeverage: '',
        shortP: '',
        midP: '',
        longP: '',
        isPointShow: false,
      };
    },
    filters: {
      isM: function (val) {
        return val == 'male' ? 'images/male.png' : 'images/female.pn';
      },
    },
    watch: {
      $route(to, from) {
        //console.log(from.path); // 从哪来pathpath
        //监听跳转问题反馈变换背景图
        this.path = to.path;
        this.messagePath = to.path;
        // console.log(to.path); // 到哪去
      },
    },
    created() {
      this.getInboxData();
      this.getBindingData();
      //发送登陆事件
      this.$EventBus.$on('changedialogFormVisible', () => {
        this.dialogFormVisible = true;
      });
      if (this.$router.history.current.path !== '/PrivaTeLetter') {
        this.letterFlag = true;
      }
      //console.log(this.isShow);
    },
    computed: {},
    inject: ['reload'],
    mounted() {
      this.getCookie();
      this.load_data();
    },
    methods: {
      // cancelClick() {
      //   this.$confirm('是否取消?', '提示', {
      //     cancelButtonText: '取消',
      //     confirmButtonText: '确定',
      //     type: 'warning',
      //     customClass: 'cancel-confirm',
      //   })
      //     .then(() => {
      //       this.dotmapClick();
      //     })
      //     .catch(() => {
      //       this.dotmapDialog = false;
      //       this.$message({
      //         type: 'success',
      //         message: '取消成功!',
      //       });
      //     });
      // },
      //点阵图增加
      async dotmapClick() {
        this.tableData.forEach((item) => {
          //开仓方向
          item.shortPositionSide =
            item.shortIsPosition == 1 ? item.shortPositionSide : 'none';
          item.midPositionSide =
            item.midIsPosition == 1 ? item.midPositionSide : 'none';
          item.longPositionSide =
            item.longIsPosition == 1 ? item.longPositionSide : 'none';
          //杠杆倍数
          item.shortPositionLeverage =
            item.shortIsPosition === 0 ? 0 : item.shortPositionLeverage;
          item.midPositionLeverage =
            item.midIsPosition === 0 ? 0 : item.midPositionLeverage;
          item.longPositionLeverage =
            item.longIsPosition === 0 ? 0 : item.longPositionLeverage;
        });
        //console.log('添加=====', this.tableData);

        let params = {
          date: (this.timeArr = this.dateTypeFormat('YYYY-mm-dd', new Date())),
          data: this.tableData,
        };
        const { data: res } = await addPoint(params);
        //console.log(res);
        if (res.code == 0) {
          this.dotmapDialog = false;
          this.$message({
            type: 'success',
            message: res.msg,
          });
        }
      },
      //打开增加点阵图后台页面
      dotomapOppen() {
        this.dotmapDialog = true;
        this.findBitmapInformationData();
      },
      //获取点阵图信息
      async findBitmapInformationData() {
        this.tableData = [];
        const { data: res } = await sendPointShow(this.currentTime);
        if (res.code == 0) {
          let points = res.data;
          points.forEach((item) => {
            //console.log(item.shortIsPosition);
            let shortIsPosition = '';
            //是否开仓
            this.aaa = item.shortIsPosition ? 1 : 0;
            this.bbb = item.midIsPosition ? 1 : 0;
            this.ccc = item.longIsPosition ? 1 : 0;
            //console.log('返回数据======', item.shortPositionSide);
            const pointObj = {
              user_id: item.user.id,
              shortPoint: item.shortPoint,
              shortIsPosition: this.aaa,
              shortPositionSide: item.shortPositionSide,
              shortPositionLeverage: item.shortPositionLeverage,
              midPoint: item.midPoint,
              midIsPosition: this.bbb,
              midPositionSide: item.midPositionSide,
              midPositionLeverage: item.midPositionLeverage,
              longPoint: item.longPoint,
              longIsPosition: this.ccc,
              longPositionSide: item.longPositionSide,
              longPositionLeverage: item.longPositionLeverage,
            };
            this.tableData.push(pointObj);
          });
          //console.log('fuzh====', this.tableData);
        }
        //console.log('获取点阵图信息', res);
      },
      //获取绑定交易所名单所有数据
      async getBindingData(id) {
        const { data: res } = await getBindingList();
        //  console.log('绑定交易所名单所有数据:', res.data);
        let bindings = res.data;
        bindings.forEach((item) => {
          const apiNameObj = {
            id: item.id,
            name: item.name,
          };

          this.apiNameArr.push(apiNameObj);
        });
        //console.log('要封装的api信息', this.apiNameArr);
        this.$store.commit('changeApiValue', this.apiNameArr);
        //console.log(this.$store.state.apiNameArr);
      },
      replays() {
        this.detailDialog = false;
        this.replayClick = true;
      },
      //用户头像点击跳转用户详情
      async userClick() {
        //console.log();
        // let params = {
        //   targetUUID: id,
        // };
        const { data: res } = await getUserAsset();

        if (res.code == 10001) {
          alert('没有权限查看');
          return;
        }
        this.$router.replace({ path: '/User' });
      },
      //问题反馈跳转
      questionClick() {
        // this.$refs.questionRefs.style.display = 'none';
        // this.$refs.quRefs.style.display = 'flex';
        this.$router.replace({ path: 'Question' });
        this.flag = false;
      },
      //登录按钮事件
      isLoginClick() {
        this.dialogFormVisible = true;
        // watc
      },
      //关闭对话框事件
      resetRegister() {
        // 重置登录信息
        this.fromData.name = '';
        this.fromData.password = '';
        this.dialogFormVisible = false;
      },
      //退出登录
      async logoutClick() {
        const { data: res } = await getLogout();
        //console.log('退出登录', res);
        if (res.code === 0) {
          //登录成功后强制刷新当前页面无空白
          this.reload();
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          this.$refs.loginRef.style.display = 'flex';
          this.$refs.popoverRef.style.display = 'none';

          this.$router.replace({ path: '/Home' });
          this.$store.commit('changeLogin', '0');
          this.dialogFormVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      },
      //获取收件箱全部数据
      async getInboxData() {
        let params = {
          pageIndex: 1,
          pageSize: 300,
        };
        const { data: res } = await getMessageInbox(params);
        if (res.data.length == 0) {
          this.$refs.tableRef.style.display = 'none';
          this.$refs.nullRef.style.display = 'flex';
        } else {
          this.$refs.tableRef.style.display = 'flex';
          this.$refs.nullRef.style.display = 'none';
          let inboxs = res.data;
          //console.log(inboxs);
          inboxs.forEach((item) => {
            const inboxObj = {
              messageName: item.from.name,
              messageId: item.messageId,
              isRead: item.isRead,
              sendTime: item.sendTime,
            };
            this.inboxData.push(inboxObj);

            //对数组对象中key isRead == false的对象筛选出来房租一个空数组
            this.inboxNum = this.inboxData.filter(function (res) {
              return res.isRead == false;
            });
          });
        }
      },

      //私信popover触发事件
      openShow() {
        // this.isClick = true;
      },
      doShow() {
        this.isClick = true;
      },
      doClose() {
        this.isClick = false;
      },
      //私信跳转事件
      viewAllClick() {
        this.$router.replace({ path: '/PrivaTeLetter' });
        //this.$refs.ploRefs.style.display = 'none';
      },
      //rtalogo跳转首页
      headerLogoClick() {
        this.$router.replace({ path: '/' });
      },
      //实盘管理跳转事件
      privateLetterClick() {
        this.$router.replace({ path: '/FirmManagement' });
      },

      // 根据私信ID获取私信内容
      async findByIdMessageInfo(id) {
        const { data: res } = await getMessageInfoContent({
          messageId: id,
        });
        //收件箱
        this.replayForm.uuid = res.data.form.uuid;
        this.user = '与' + res.data.form.name + '私信';
        this.replayForm.replyContent = res.data.subject;
        this.replayForm.replyL = '回复 ' + res.data.form.name + ' 私信';
        this.replayForm.replyTime = this.dateTypeFormat(
          'YY-mm-dd HH:MM',
          new Date(res.data.sendTime)
        );
        this.replayForm.replayLetter = res.data.content;
      },

      //点击主题跳转私信详情
      detailClick(id) {
        this.user = '';
        this.replayForm.replyContent = '';
        this.replayForm.replyTime = '';
        this.replayForm.replayLetter = '';
        this.findByIdMessageInfo(id);
        this.detailDialog = true;
      },
      //写私信对话框
      handleClose(done) {
        this.$confirm('', '确认关闭？')
          .then((_) => {
            done();
            this.eoistolizForm.name = [];
            this.eoistolizForm.subject = '';
            this.eoistolizForm.textarea = '';
          })
          .catch((_) => { });
      },
      //收件箱回复私信取消
      replayReset(formName) {
        this.replayClick = false;
        this.$refs[formName].resetFields();
      },
      //收件箱回复私信
      async submitForm(formName) {
        let sendMessageObj = {
          uuid: this.replayForm.uuid,
          subject: this.replayForm.replyContent,
          content: this.replayForm.textarea,
        };
        const { data: res } = await getMessageSendInfo(sendMessageObj);

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message(res.msg);
            this.replayClick = false;
            this.replayForm.replyContent = '';
            this.replayForm.replayLetter = '';
            this.replayForm.textarea = '';
          }
        });
      },
      //私信消息清除按钮事件
      clearAwarClick() {
        this.messageDisplay = false;
      },
      // 设置Cookie
      setCookie(username, password, exdays) {
        // 用户名, 密码, 保存天数
        let exdate = new Date(); // 获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
        // 字符串拼接cookie
        window.document.cookie =
          'userName=' + username + ';path=/;expires=' + exdate.toGMTString();
        window.document.cookie =
          'userPwd=' + password + ';path=/;expires=' + exdate.toGMTString();
      },

      // 读取Cookie
      getCookie() {
        if (document.cookie.length > 0) {
          let arr = document.cookie.split('; ');
          for (let i = 0; i < arr.length; i++) {
            let arr2 = arr[i].split('='); // 再次切割
            // 判断查找相对应的值
            if (arr2[0] === 'userName') {
              this.fromData.name = arr2[1]; // 保存到保存数据的地方
            } else if (arr2[0] === 'userPwd') {
              this.fromData.password = arr2[1];
            }
          }

          this.isRemember = true;
        }
      },

      // 清除Cookie
      clearCookie() {
        this.setCookie('', '', -1); // 修改2值都为空，天数为负1天
      },
      //登录事件
      submitClick() {
        this.$refs['fromData'].validate(async (valid) => {
          if (valid) {
            const { data: res } = await getUsersLogin(this.fromData);
            if (res.code == 10001) {
              this.$message.error({
                message: res.msg,
                type: '登录失败',
                duration: 1000,
              });
            } else {
              this.$message({
                message: '登录成功!',
                type: '登录成功',
                duration: 1000,
              });
              this.$EventBus.$emit('changeApi');
              this.$store.commit('changeLogin', '100');
              //登陆成功后关闭模态框
              this.dialogFormVisible = false;
              this.resetRegister();
              // 存储数据到localStoreage
              //console.log('token', res);
              localStorage.setItem('token', res.data);
              // 请求用户数据
              const { data: userres } = await getUserInfo();
              // console.log('用户数据', userres.data);
              this.isPointShow = userres.data.isPointShow;
              let rtaId = userres.data.rtaId;
              //console.log('id', rtaId);
              this.isShow = rtaId == '342' || rtaId == '9' || rtaId == '916';

              //console.log('显示状态', this.isShow);
              this.letterFlag = 'https://rta.academy/user/' + rtaId;
              let userInfo = {
                about: userres.data.about,
                nickname: userres.data.nickName,
                avatar: userres.data.avatar,
                vipName: userres.data.vipName,
                accountInfos: userres.data.accountInfos,
                loginTime: Date.parse(new Date()),
                letterFlagUrl: this.letterFlag,
                isShow: this.isShow,
                isPointShow: this.isPointShow,
              };

              (this.nickName = userres.data.nickName),
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
              this.load_data();
              // 判断复选框是否被勾选; 勾选则调用配置Cookie方法
              if (this.isRemember) {
                // 记住密码
                this.setCookie(this.fromData.name, this.fromData.password, 30); // 保存期限为30天
              } else {
                this.clearCookie(); // 清空 Cookie
              }
              this.getInboxData();
            }
            // this.$router.go(0)
            //登录成功后强制刷新当前页面无空白
            this.reload();
          }
        });
      },
      //页面刚加载的时候，开始判断，如果有用户名，就显示在页面上，如果没有用户名的话，就显示登录名称
      async load_data() {
        var theme = localStorage.getItem('token');
        if (theme == null || theme == '') {
          // 未登录不显示用户信息
          this.$refs.popoverRef.style.display = 'none';
        } else {
          // 显示用户信息
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          //console.log("用户信息",userInfo)
          this.nickName = userInfo.nickname;
          this.vipName = userInfo.vipName;
          this.avatar = userInfo.avatar;
          this.isPointShow = userInfo.isShow;
          this.letterFlagUrl = userInfo.letterFlagUrl;
          this.$refs.popoverRef.style.display = 'flex';
          this.$refs.loginRef.style.display = 'none';
          var text = this.vipName;
          //console.log('1111', this.isPointShow);
          //根据名字获取相应的图片

          if (text == null) {
            this.imgUrl = '';
          } else {
            switch (text) {
              case 'A1':
                this.imgUrl = require('@/assets/img/rtaLogo/A1.svg');
                break;
              case 'A2':
                this.imgUrl = require('@/assets/img/rtaLogo/A2.svg');
                break;
              case 'A3':
                this.imgUrl = require('@/assets/img/rtaLogo/A3.svg');
                break;
              case 'A4':
                this.imgUrl = require('@/assets/img/rtaLogo/A4.svg');
                break;
              case 'A5':
                this.imgUrl = require('@/assets/img/rtaLogo/A5.svg');
                break;
              case 'A6':
                this.imgUrl = require('@/assets/img/rtaLogo/A6.svg');
                break;
              case 'A7':
                this.imgUrl = require('@/assets/img/rtaLogo/A7.svg');
                break;
              case 'A8':
                this.imgUrl = require('@/assets/img/rtaLogo/A8.svg');
                break;
              case 'A9':
                this.imgUrl = require('@/assets/img/rtaLogo/A9.svg');
                break;
            }
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  #overall_arrangement {
    margin: -8px -8px auto !important;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    height: 63px !important;

    .header-body {
      width: 1200px;
      display: flex;
      justify-content: space-between;

      .logo {
        width: 132px;
        text-align: left;
        display: flex;
        align-items: center;

        img {
          height: 24px;
        }
      }

      .opt-wrapper {
        height: 64px !important;
        //width: 100%;
        text-align: right;
        display: flex;
        justify-content: space-between;

        .el-button {
          padding: 0;
          margin: 20px 16px 0 0;
          width: 24px;
          height: 24px;

          .btnUp {
            width: 100px;
            height: 100px;
            background: url(../assets/img/rtaLogo/question-o.svg) no-repeat;
            pointer-events: none;
          }
        }

        // .el-button--text.is-active,
        .el-button--text:active {
          .btnUp {
            width: 100px;
            height: 100px;
            pointer-events: auto;
            background: url(../assets/img/rtaLogo/question.svg) no-repeat;
          }
        }

        span {
          .el-popover__reference-wrapper {
            .private-letter-img {
              margin-top: 20px !important;
              padding: 0;
              position: relative;

              span {
                .num {
                  font-size: 13px;
                  justify-content: center;
                  font-family: Roboto-Regular, Roboto;
                  font-weight: 400;
                  color: #ffffff;
                  line-height: 16px;
                  width: 16px;
                  height: 16px;
                  border-radius: 10px;
                  background: red;
                  position: absolute;
                  right: -2px;
                  top: -4px;
                }
              }
            }

            // .private-letter-img:active {
            //   background: url(../assets/img/rtaLogo/private-letter-y.svg) no-repeat;
            // }
          }
        }

        .login {
          .el-button {
            //width: 48px;
            color: #fff !important;
            padding: 0;

            span {}
          }
        }

        .logging-status {

          // margin-left: 24px;
          .headPortrait {
            //margin-right: 20px;

            .el-popover__reference-wrapper {
              display: flex;
              flex-direction: row;

              .el-popover__reference {
                padding: 0 0;
                margin-top: 18px;
                border-radius: 50%;
                width: 36px;
                height: 36px;

                span {
                  img {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                  }
                }
              }
            }

            .el-table__body-wrapper {
              .el-table__body {
                .el-table__row {
                  height: 48px !important;
                }
              }
            }
          }
        }
      }
    }
  }

  .inputDeep>>>.el-input__inner {
    border: 0;
  }

  .el-popover {
    background: rgba(51, 53, 62, 1) !important;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
      0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
    border-radius: 4px !important;
    border: none;
    margin: 0 !important;
    padding: 0 !important;
  }
</style>
<style lang="scss">
  .el-dialog__header .el-dialog__close:hover {
    color: #efc394;
    /* 这里设置悬停时的颜色 */
  }

  .previewDialog {
    .el-dialog {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;

      .el-dialog__header {
        padding: 0 !important;

        .el-dialog__headerbtn {
          top: 35px !important;
          right: 25px !important;

          .el-icon-close {
            font-size: 24px !important;
          }
        }
      }

      .el-dialog__body {
        padding: 0 !important;
        width: 100%;
        height: 100%;
        padding: 0 !important;
        width: 100%;
        height: 100%;
        box-shadow: 0px 2px 40px -40px rgba(0, 0, 0, 0.6);
        background: url('../assets/img/login/login.svg') center center no-repeat;

        .popup-content {
          display: flex;
          //justify-content: space-between;
          width: 100%;

          .loginLeft {
            width: 60% !important;
            height: 100%;
            text-align: center;
            margin-top: 265px;

            img {
              width: 456px;
              height: 233px;
            }
          }

          .loginRight {
            width: 40%;
            height: 100%;
            padding: 75px 0 80px 111px;

            .loginTittle {
              height: 21px;
              text-align: center;
              margin-bottom: 22px;
              line-height: 21px;

              span {
                height: 21px;
                font-size: 16px;
                font-weight: 600;
                color: #616161;
              }
            }

            img {
              // width: 364px;
              height: 40px;
            }

            .title {
              text-align: left;
              font-size: 20px;
              font-family: MicrosoftYaHei;
              color: #ffffff;
              line-height: 32px;
              letter-spacing: 11px;
              margin-top: 15px;
            }

            .el-form {
              text-align: left;
              margin-top: 60px;

              .el-form-item {
                .el-form-item__content {
                  width: 364px;

                  span {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 20px;
                  }

                  .el-input {
                    .el-input__inner {
                      background: rgba(255, 255, 255, 0.1) !important;
                      border-radius: 4px !important;
                      border: 1px solid #979797 !important;
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #eaeaea;
                      line-height: 18px;
                    }

                    .el-input__inner:focus {}
                  }

                  .el-form-item__error {
                    font-size: 12px;
                    font-family: MicrosoftYaHei;
                    color: #ff3040;
                    line-height: 16px;
                  }
                }
              }

              .el-input__inner {
                -webkit-appearance: none !important;
                background-color: #fff !important;
                background-image: none !important;
                border-radius: 0 !important;
                border: 0px !important;
                border-bottom: 1px solid #cccccc !important;
                width: 100% !important;
                height: 48px;
              }

              .el-select .el-input__inner {
                border-left: 0px !important;
                padding-left: 0 !important;
              }

              .pasEye {
                .el-form-item__content {
                  width: 30%;

                  span {
                    line-height: 48px !important;
                  }
                }

                span {
                  color: #bfbfbf;
                  float: right;
                  line-height: 40px;

                  .svg-icon {
                    font-size: 20px;
                  }
                }
              }
            }

            .dialog-footer {
              margin-top: 60px;

              .el-button--primary {
                border: none;
                width: 364px;
                height: 48px;
                background: #efc394;
                border-radius: 4px;
                margin: 0 !important;

                span {
                  font-size: 16px;
                  font-family: ArialMT;
                  color: #000000;
                  line-height: 24px;
                  font-weight: 600;
                }
              }
            }

            .sign_in {
              margin-top: 8px;
              display: flex;
              justify-content: space-between;
              width: 364px;

              .checked {
                margin-bottom: 16px;

                .el-checkbox__input.is-checked+.el-checkbox__label {
                  color: rgba(153, 153, 153, 1);
                }
              }

              .el-checkbox {
                color: rgba(153, 153, 153, 1);
              }

              .el-checkbox__inner:hover {
                border-color: #b29170 !important;
              }

              .el-checkbox__inner {
                border-color: #606266;
                color: rgba(153, 153, 153, 1);
              }

              .el-checkbox__input.is-checked .el-checkbox__inner,
              .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background-color: rgba(239, 195, 148, 1) !important;
                border-color: rgba(239, 195, 148, 1) !important;
              }

              .el-checkbox__input.is-checked+.el-checkbox__label {
                color: rgba(153, 153, 153, 1);
              }

              a {
                background: transparent !important;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(239, 195, 148, 1);
                line-height: 18px;
                border: none;
                text-decoration: none;
              }
            }

            .secondPane .input-with .el-input__inner {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .messagePopover {
    .el-table .el-table__body-wrapper .el-table__body .el-table__row {
      height: 48px !important;
    }

    .el-table {
      background: rgba(51, 53, 62, 1) !important;

      .el-table__body-wrapper {
        .el-table__empty-block {
          .el-table__empty-text {
            width: 53.4%;
            line-height: 100%;

            .el-empty {
              padding: 66px 0 67px 0;

              .el-empty__image {
                width: 100% !important;

                img {
                  width: 160px;
                  height: 80px;
                }
              }

              .el-empty__description {
                margin-top: 16px;

                p {
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc;
                }
              }
            }
          }
        }
      }
    }
  }

  .el-popover {
    background: rgba(51, 53, 62, 1) !important;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
      0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
    border-radius: 4px !important;
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;

    .popover-header {
      height: 23px;
      padding: 16px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .popover-box {
        display: flex;
        justify-content: space-between;

        margin: 0 16px;

        span {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          line-height: 24px;
        }

        .el-button {
          padding: 0;
          width: 26px;
          height: 24px;
          margin: 0;

          span {
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: rgba(209, 212, 220, 0.6);
          }
        }
      }
    }

    .popover-content {
      width: 100%;
      height: 245px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .el-table--enable-row-hover .el-table__body tr:hover>td {
        background: rgba(255, 255, 255, 0.1) !important;
        color: #33353e;
      }

      .el-table {
        tr {
          background: rgba(51, 53, 62, 1) !important;

          .el-table__cell {
            .cell {
              .el-button {
                text-align: left;
                width: 100%;
                height: 48px;
                padding: 0;

                span {
                  display: flex;
                  justify-content: space-between;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                  line-height: 48px;

                  .messageName {
                    width: fit-content !important;
                    max-width: 80px !important;
                    white-space: nowrap !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                  }

                  .sendtime {
                    font-size: 12px;
                    font-family: Roboto-Regular;
                    color: rgba(209, 212, 220, 0.7);
                  }
                }
              }
            }
          }
        }

        tr:hover {
          background: rgba(255, 255, 255, 0.1) !important;
        }

        .el-table__cell {
          padding: 0 !important;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);

          .cell {
            margin: 0 16px 0 16px;
            padding: 0 !important;
            height: 48px;
            line-height: 48px;
          }
        }

        .el-table__header-wrapper {
          display: none;
        }
      }
    }

    .popover-err {
      justify-content: center;

      .inbox-error {
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;

        img {
          width: 160px;
          height: 80px;
        }

        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          line-height: 19px;
        }
      }
    }

    .popover-f {
      width: 100%;
      height: 56px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      .el-button {
        width: 100%;
        height: 56px;
        margin: 0;
        padding: 0;
        text-align: center;
      }

      span {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
      }
    }

    .loginPopover {
      // display: flex;
      // flex-direction: column;

      border-radius: 4px;
      width: 100%;

      .user-name {
        width: 100%;
        margin: 0 auto;
        font-size: 16px !important;
        color: #ffffff;
        padding: 16px 0 15px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .vip_avatar {
          position: relative;

          .vipPic {
            width: 100%;
            margin-left: 5px;
            position: absolute;
            top: 30px;
            left: -5px;

            img {
              width: 40px;
              height: 16px;
            }
          }

          .avatar {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            text-align: center;
            margin: 0 auto;

            img {
              width: 48px;
              height: 48px;
              border-radius: 50%;
            }
          }
        }

        .nickName {
          margin: 0 16px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }

      .user-button {
        width: 100%;
        margin: 4px 0 4px 0;

        .el-button {
          width: 100%;
          margin: 0;
          height: 40px;

          padding: 0 !important;

          span {
            font-size: 14px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #ffffff !important;
            line-height: 21px;

            a {
              text-decoration: none;
              font-size: 14px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }
      }

      .log_out {
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        .el-button {
          width: 100%;
          margin: 0;
          height: 40px;
          margin: 4px 0 4px 0;
          padding: 0 !important;

          span {
            font-size: 14px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #ffffff !important;
            line-height: 21px;
          }
        }
      }

      .el-button {

        //padding: 0 0 0 0 !important;
        // border-top: 1px solid rgba(255, 255, 255, 0.1);
        span {
          color: #efc394;
        }
      }
    }
  }

  .el-message-box__wrapper {
    width: 100%;
    position: fixed;
    top: 0;
    bottom: -25px;
    left: 0;
    right: 550px;
    text-align: center;

    .el-message-box {
      width: 384px;
      height: 126px !important;
      background: rgba(51, 53, 62, 1);
      border: none;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2),
        0px 6px 16px 0px rgba(22, 23, 28, 0.32),
        0px 3px 6px -4px rgba(51, 53, 62, 0.48);
      border-radius: 4px;
      padding-bottom: 0 !important;

      .el-message-box__header {
        padding: 16px 26px 25px 22px !important;
        height: 26px;

        .el-message-box__title {
          width: 320px !important;

          span {
            width: 64px;
            height: 24px;
            font-size: 16px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.85);
            line-height: 24px;
          }
        }

        .el-message-box__headerbtn {
          top: 26px !important;
          right: 26px !important;

          .el-message-box__close {}
        }
      }

      .el-message-box__content {
        padding: 0 15px;

        .el-message-box__container {
          .el-message-box__message {
            p {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: rgba(255, 255, 255, 0.65);
              line-height: 22px;
            }
          }
        }
      }

      .el-message-box__btns {
        height: 24px !important;
        padding: 0 26px 16px 15px !important;

        .el-button {
          width: 49px;
          height: 24px;
          border-radius: 2px;
          background: #33353e;
          border: 1px solid rgba(255, 255, 255, 0.2);

          span {
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.65);
          }
        }

        .el-button--primary {
          background: #edbd88;

          span {
            color: #33353e;
          }
        }

        .el-button--small {
          padding: 0;
        }
      }
    }
  }

  .privaTetterDialog {
    .el-dialog {
      //height: 100% !important;
      background: #33353e !important;
      border-radius: 8px;

      .el-dialog__header {
        height: 70px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        .el-dialog__title {
          line-height: 71px;
          font-size: 20px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          margin-left: 20px;
        }
      }

      .el-dialog__body {
        //   height: 100%;
        margin: 35px 20px 16px 20px;

        //私信详情
        .el-form {
          .el-form-item {
            margin-bottom: 12px !important;

            .el-form-item__label {
              height: 20px !important;
              line-height: 20px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: rgba(209, 212, 220, 0.7);
              text-align: justify;
            }

            .el-form-item__label::after {
              content: ' ';
              width: 100%;
              display: inline-block;
            }

            .el-form-item__content {
              height: 20px !important;
              line-height: 20px !important;

              .el-select {
                .el-select__tags {
                  .el-select__input {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc !important;
                  }
                }

                .el-input {
                  .el-input__inner {
                    border: none;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 4px;
                  }

                  .el-input__suffix {
                    display: none;
                  }
                }
              }

              .el-input {
                .el-input__inner {
                  height: 20px !important;
                  line-height: 20px;
                  background: none !important;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                  border: none;
                }
              }

              .textarea {
                height: 330px !important;

                .el-input__inner {
                  height: 330px !important;
                  overflow-y: auto;
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                }

                .el-input__suffix {
                  .el-input__suffix-inner {
                    .el-input__count {

                      // display: inline-flex;
                      // align-items: flex-end;
                      .el-input__count-inner {
                        background: transparent;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #d1d4dc;
                        padding: 16px 16px;
                      }
                    }
                  }
                }
              }

              .el-textarea {
                .el-textarea__inner {
                  resize: none;
                  height: 330px !important;
                  overflow-y: auto;
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                  max-height: 330px;
                  min-height: 330px !important;
                  padding: 12px 16px 16px 16px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }

          .content-row {
            height: 46px !important;
            line-height: 46px !important;

            .el-form-item__content {
              .el-textarea {
                .el-textarea__inner {
                  resize: none;
                  height: 46px !important;
                  overflow-y: auto;
                  border: none;
                  background: none;
                  border-radius: 4px;
                  max-height: 46px;
                  min-height: 46px !important;
                  padding: 0 12px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden; //溢出内容隐藏
                  text-overflow: ellipsis; //文本溢出部分用省略号表示
                  display: -webkit-box; //特别显示模式
                  -webkit-line-clamp: 2; //行数
                  line-clamp: 2;
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }

          .textarea-item {
            margin: 24px 0 !important;

            .el-form-item__content {
              height: 330px !important;
            }
          }
        }
      }

      .el-dialog__footer {
        padding: 8px 20px 30px;

        .dialog-footer {
          .el-button {
            line-height: 32px !important;
            width: 72px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            background: rgba(51, 53, 62, 1);
            margin: 0 0 0 12px !important;
            padding: 0 !important;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
            }
          }

          .el-button--primary {
            background: #edbd88 !important;
            border: none;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #33353e;
            }
          }
        }
      }
    }
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    font-size: 14px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #d1d4dc;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px 0px 0px 4px;
  }

  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
    font-size: 14px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #d1d4dc;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px 0px 0px 4px;
  }

  .privaTetterDialog {
    .el-dialog {
      //height: 100% !important;
      background: #33353e !important;
      border-radius: 8px;
      -webkit-box-shadow: none !important;

      .el-dialog__header {
        height: 70px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        .el-dialog__title {
          line-height: 71px;
          font-size: 20px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          margin-left: 20px;
        }
      }

      .el-dialog__body {
        height: 421px;
        margin: 35px 20px 0 20px;

        //私信详情
        .el-form {
          height: 421px;

          .el-form-item {
            margin-bottom: 12px !important;

            .el-form-item__label {
              height: 20px !important;
              line-height: 20px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: rgba(209, 212, 220, 0.7);
              text-align: justify;
            }

            .el-form-item__label::after {
              content: ' ';
              width: 100%;
              display: inline-block;
            }

            .el-form-item__content {
              height: 20px !important;
              line-height: 20px !important;

              .el-select {
                .el-select__tags {
                  .el-select__input {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc !important;
                  }
                }

                .el-input {
                  .el-input__inner {
                    border: none;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 4px;
                  }

                  .el-input__suffix {
                    display: none;
                  }
                }
              }

              .el-input {
                .el-input__inner {
                  height: 20px !important;
                  line-height: 20px;
                  background: none !important;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                  border: none;
                }
              }

              // .textarea {
              //   height: 330px !important;
              //   .el-input__inner {
              //     height: 330px !important;
              //     overflow-y: auto;
              //     border: none;
              //     background: rgba(255, 255, 255, 0.1);
              //     border-radius: 4px;
              //   }
              //   .el-input__suffix {
              //     .el-input__suffix-inner {
              //       .el-input__count {
              //         // display: inline-flex;
              //         // align-items: flex-end;
              //         .el-input__count-inner {
              //           background: transparent;
              //           font-size: 14px;
              //           font-family: PingFangSC-Regular, PingFang SC;
              //           font-weight: 400;
              //           color: #d1d4dc;
              //           padding: 16px 16px;
              //         }
              //       }
              //     }
              //   }
              // }
              .el-textarea {
                .el-textarea__inner {
                  resize: none;
                  height: 330px !important;
                  overflow-y: auto;
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                  max-height: 330px;
                  min-height: 330px !important;
                  padding: 12px 16px 16px 16px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }

          .content-row {
            height: 46px !important;
            line-height: 46px !important;
            margin-bottom: 24px !important;

            .el-form-item__content {
              .el-textarea {
                .el-textarea__inner {
                  resize: none;
                  height: 46px !important;
                  overflow-y: auto;
                  border: none;
                  background: none;
                  border-radius: 4px;
                  max-height: 46px;
                  min-height: 46px !important;
                  padding: 0 12px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden; //溢出内容隐藏
                  text-overflow: ellipsis; //文本溢出部分用省略号表示
                  display: -webkit-box; //特别显示模式
                  -webkit-line-clamp: 2; //行数
                  line-clamp: 2;
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }

          .textarea-item {
            margin: 24px 0 0 0 !important;

            .el-form-item__content {
              height: 330px !important;
            }
          }

          // .replyTextarea {
          //   margin-bottom: 0 !important;
          //   height: 314px !important;
          //   .el-form-item__content {
          //     height: 314px !important;
          //     .el-textarea {
          //       height: 314px !important;
          //       .el-textarea__inner {
          //         resize: none;
          //         height: 314px !important;
          //         overflow-y: auto;
          //         border: none;
          //         background: rgba(255, 255, 255, 0.1);
          //         border-radius: 4px;
          //         max-height: 314px;
          //         min-height: 314px !important;
          //         padding: 12px 16px 16px 16px;
          //         font-size: 14px;
          //         font-family: MicrosoftYaHei;
          //         color: rgba(209, 212, 220, 1);
          //       }
          //       .el-input__count {
          //         background: transparent;
          //         font-size: 14px;
          //         font-family: PingFangSC-Regular, PingFang SC;
          //         font-weight: 400;
          //         color: #d1d4dc;
          //       }
          //     }
          //   }
          // }
        }
      }

      .el-dialog__footer {
        padding: 24px 20px 32px;

        .dialog-footer {
          .el-button {
            line-height: 32px !important;
            width: 72px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            background: rgba(51, 53, 62, 1);
            margin: 0 0 0 12px !important;
            padding: 0 !important;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
            }
          }

          .el-button--primary {
            background: #edbd88 !important;
            border: none;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #33353e;
            }
          }
        }
      }
    }
  }

  .answerLetterDialog {
    .el-dialog {
      //height: 100% !important;
      background: #33353e !important;
      border-radius: 8px;
      -webkit-box-shadow: none !important;

      .el-dialog__header {
        height: 70px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

        .el-dialog__title {
          line-height: 71px;
          font-size: 20px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          margin-left: 20px;
        }
      }

      .el-dialog__body {
        height: 421px;
        margin: 35px 20px 0 20px;

        //私信详情
        .el-form {
          height: 421px;

          .el-form-item {
            margin-bottom: 12px !important;

            .el-form-item__label {
              height: 20px !important;
              line-height: 20px;
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: rgba(209, 212, 220, 0.7);
              text-align: justify;
            }

            .el-form-item__label::after {
              content: ' ';
              width: 100%;
              display: inline-block;
            }

            .el-form-item__content {
              height: 20px !important;
              line-height: 20px !important;

              .el-select {
                .el-select__tags {
                  .el-select__input {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc !important;
                  }
                }

                .el-input {
                  .el-input__inner {
                    border: none;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 4px;
                  }

                  .el-input__suffix {
                    display: none;
                  }
                }
              }

              .el-input {
                .el-input__inner {
                  height: 20px !important;
                  line-height: 20px;
                  background: none !important;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                  border: none;
                }
              }

              // .textarea {
              //   height: 330px !important;
              //   .el-input__inner {
              //     height: 330px !important;
              //     overflow-y: auto;
              //     border: none;
              //     background: rgba(255, 255, 255, 0.1);
              //     border-radius: 4px;
              //   }
              //   .el-input__suffix {
              //     .el-input__suffix-inner {
              //       .el-input__count {
              //         // display: inline-flex;
              //         // align-items: flex-end;
              //         .el-input__count-inner {
              //           background: transparent;
              //           font-size: 14px;
              //           font-family: PingFangSC-Regular, PingFang SC;
              //           font-weight: 400;
              //           color: #d1d4dc;
              //           padding: 16px 16px;
              //         }
              //       }
              //     }
              //   }
              // }
              .el-textarea {
                .el-textarea__inner {
                  resize: none;
                  height: 330px !important;
                  overflow-y: auto;
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                  max-height: 330px;
                  min-height: 330px !important;
                  padding: 12px 16px 16px 16px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }

          .content-row {
            height: 46px !important;
            line-height: 46px !important;
            margin-bottom: 24px !important;

            .el-form-item__content {
              .el-textarea {
                .el-textarea__inner {
                  resize: none;
                  height: 46px !important;
                  overflow-y: auto;
                  border: none;
                  background: none;
                  border-radius: 4px;
                  max-height: 46px;
                  min-height: 46px !important;
                  padding: 0 12px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden; //溢出内容隐藏
                  text-overflow: ellipsis; //文本溢出部分用省略号表示
                  display: -webkit-box; //特别显示模式
                  -webkit-line-clamp: 2; //行数
                  line-clamp: 2;
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }

          .textarea-item {
            margin: 24px 0 0 0 !important;

            .el-form-item__content {
              height: 330px !important;
            }
          }

          .replyTextarea {
            margin-bottom: 0 !important;
            height: 314px !important;

            .el-form-item__content {
              height: 314px !important;

              .el-textarea {
                height: 314px !important;

                .el-textarea__inner {
                  resize: none;
                  height: 314px !important;
                  overflow-y: auto;
                  border: none;
                  background: rgba(255, 255, 255, 0.1);
                  border-radius: 4px;
                  max-height: 314px;
                  min-height: 314px !important;
                  padding: 12px 16px 16px 16px;
                  font-size: 14px;
                  font-family: MicrosoftYaHei;
                  color: rgba(209, 212, 220, 1);
                }

                .el-input__count {
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                }
              }
            }
          }
        }
      }

      .el-dialog__footer {
        padding: 24px 20px 32px;

        .dialog-footer {
          .el-button {
            line-height: 32px !important;
            width: 72px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            background: rgba(51, 53, 62, 1);
            margin: 0 0 0 12px !important;
            padding: 0 !important;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
            }
          }

          .el-button--primary {
            background: #edbd88 !important;
            border: none;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #33353e;
            }
          }
        }
      }
    }
  }

  .dotmapDialog {
    .el-dialog {
      width: 100% !important;
      background: #33353e !important;
      border-radius: 8px;
      margin-top: 0 !important;
      padding: 134px 0 116px 0;

      .el-dialog__header {
        display: none;
      }

      .el-dialog__body {
        text-align: center !important;

        .body {
          display: flex;
          flex-direction: column;
          align-items: center;

          .tittle {
            width: 1180px;
            font-size: 18px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: #d1d4dc;
            text-align: left !important;
            margin-bottom: 15px;
          }

          //   height: 100%;
        }

        margin: 0 0 20px 0;
      }

      .el-dialog__footer {
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .dialog-footer {
          width: 1180px;

          .el-button {
            line-height: 32px !important;
            width: 72px;
            height: 32px;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            background: rgba(51, 53, 62, 1);
            margin: 0 0 0 12px !important;
            padding: 0 !important;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
            }
          }

          .el-button--primary {
            background: #edbd88 !important;
            border: none;

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #33353e;
            }
          }
        }
      }
    }

    .dotmapTable td,
    .dotmapTable th.is-leaf,
    .el-table--border,
    .el-table--group {
      //border: 1px solid #666666 !important;
    }

    // .el-table--border::after, .el-table--group::after, .dotmapTablee::before{
    //   background-color:1px solid black !important;
    // }
    .dotmapTable {
      border-top: 1px solid #666666 !important;
      border-left: 1px solid #666666 !important;

      .el-table__header-wrapper {
        .el-table__header {
          .is-group {
            tr {
              .el-table__cell {
                padding: 0 !important;
                // height: 79px;
                // line-height: 79px;
                background: #393b42 !important;
                //border: 1px solid #666666;
                border-bottom: 1px solid #666666 !important;
                border-right: 1px solid #666666 !important;

                .cell {
                  padding: 0 !important;
                  text-align: center;
                  font-size: 12px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc;
                }
              }
            }
          }
        }
      }

      .el-table__body-wrapper {
        .el-table__body {
          .el-table__row {
            .el-table__cell {
              padding: 0px 0px;
              border-bottom: 1px solid #666666 !important;
              border-right: 1px solid #666666 !important;
              background: #33353e !important;

              .cell {
                text-align: center;
                padding: 0px;
                font-size: 12px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;

                .el-input {
                  .el-input__inner {
                    margin: 0 auto;
                    text-align: center;
                    border: none;
                    padding: 0px;
                    background: #33353e !important;
                    font-size: 12px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                  }
                }

                .dotmapTable-name {
                  .el-input__suffix {
                    display: none !important;
                  }
                }

                .el-select {
                  .el-input {
                    .el-input__inner {
                      font-size: 12px;
                      font-family: MicrosoftYaHei;
                      color: #d1d4dc;
                    }

                    .el-input__suffix {
                      right: 0 !important;

                      .el-input__suffix-inner {
                        i {
                          font-size: 10px;
                          margin-left: 5px;
                        }
                      }
                    }
                  }
                }

                .el-radio-group {
                  .el-radio__input.is-checked .el-radio__inner {
                    border-color: rgba(230, 190, 143, 1);
                    background: rgba(230, 190, 143, 1);
                  }

                  .el-radio__input.is-checked+.el-radio__label {
                    color: #d1d4dc;
                  }

                  .el-radio {
                    margin: 0 !important;

                    .el-radio__input {
                      .el-radio__inner {
                        width: 12px;
                        height: 12px;

                        .el-radio__original {}
                      }
                    }

                    .el-radio__label {
                      padding: 0 5px 0 8px !important;
                      font-size: 12px;
                      font-family: MicrosoftYaHei;
                      color: #d1d4dc;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .el-message-box__wrapper {
    .cancel-confirm {
      width: 300px !important;
      height: 130px !important;

      .el-message-box__header {
        padding: 16px 26px 15px 22px !important;
        height: 26px;

        .el-message-box__title {
          width: 320px !important;

          span {
            width: 64px;
            height: 24px;
            font-size: 16px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.85);
            line-height: 24px;
          }
        }

        .el-message-box__headerbtn {
          top: 26px !important;
          right: 26px !important;

          .el-message-box__close {}
        }
      }

      .el-message-box__content {
        padding: 0 15px 10px 22px !important;

        .el-message-box__container {
          .el-message-box__message {
            p {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: rgba(255, 255, 255, 0.65);
              line-height: 22px;
            }
          }
        }
      }

      .el-message-box__btns {
        height: 24px !important;
        padding: 0 26px 16px 15px !important;

        .el-button {
          width: 49px;
          height: 24px;
          border-radius: 2px;
          background: #33353e;
          border: 1px solid rgba(255, 255, 255, 0.2);

          span {
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.65);
          }
        }

        .el-button--primary {
          background: #edbd88;

          span {
            color: #33353e;
          }
        }

        .el-button--small {
          padding: 0;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue